/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getHospitalManagers } from 'app/entities/hospital-manager/hospital-manager.reducer';
import { createEntity, getEntity, reset, updateEntity } from './operation-theatre.reducer';

export const OperationTheatreUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitals = useAppSelector(state => state.hospital.entities);
  const hospitalManagers = useAppSelector(state => state.hospitalManager.entities);
  const operationTheatreEntity = useAppSelector(state => state.operationTheatre.entity);
  const loading = useAppSelector(state => state.operationTheatre.loading);
  const updating = useAppSelector(state => state.operationTheatre.updating);
  const updateSuccess = useAppSelector(state => state.operationTheatre.updateSuccess);

  const handleClose = () => {
    navigate(`/operation-theatre${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitals({}));
    dispatch(getHospitalManagers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.startTime !== undefined && typeof values.startTime !== 'number') {
      values.startTime = Number(values.startTime);
    }
    if (values.endTime !== undefined && typeof values.endTime !== 'number') {
      values.endTime = Number(values.endTime);
    }
    if (values.dateSuspended !== undefined && typeof values.dateSuspended !== 'number') {
      values.dateSuspended = Number(values.dateSuspended);
    }
    if (values.nextMaintenanceDate !== undefined && typeof values.nextMaintenanceDate !== 'number') {
      values.nextMaintenanceDate = Number(values.nextMaintenanceDate);
    }
    if (values.lastMaintenanceDate !== undefined && typeof values.lastMaintenanceDate !== 'number') {
      values.lastMaintenanceDate = Number(values.lastMaintenanceDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...operationTheatreEntity,
      ...values,
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      addedBy: hospitalManagers.find(it => it.id.toString() === values.addedBy?.toString()),
      modifiedBy: hospitalManagers.find(it => it.id.toString() === values.modifiedBy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...operationTheatreEntity,
          hospital: operationTheatreEntity?.hospital?.id,
          addedBy: operationTheatreEntity?.addedBy?.id,
          modifiedBy: operationTheatreEntity?.modifiedBy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.operationTheatre.home.createOrEditLabel" data-cy="OperationTheatreCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.operationTheatre.home.createOrEditLabel">Create or edit a OperationTheatre</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="operation-theatre-id"
                  label={translate('tinyMedicRestApp.operationTheatre.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.name')}
                id="operation-theatre-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.description')}
                id="operation-theatre-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.startTime')}
                id="operation-theatre-startTime"
                name="startTime"
                data-cy="startTime"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.endTime')}
                id="operation-theatre-endTime"
                name="endTime"
                data-cy="endTime"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.dateSuspended')}
                id="operation-theatre-dateSuspended"
                name="dateSuspended"
                data-cy="dateSuspended"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.reasonSuspended')}
                id="operation-theatre-reasonSuspended"
                name="reasonSuspended"
                data-cy="reasonSuspended"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.nextMaintenanceDate')}
                id="operation-theatre-nextMaintenanceDate"
                name="nextMaintenanceDate"
                data-cy="nextMaintenanceDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.lastMaintenanceDate')}
                id="operation-theatre-lastMaintenanceDate"
                name="lastMaintenanceDate"
                data-cy="lastMaintenanceDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.suspended')}
                id="operation-theatre-suspended"
                name="suspended"
                data-cy="suspended"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.underMaintainance')}
                id="operation-theatre-underMaintainance"
                name="underMaintainance"
                data-cy="underMaintainance"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.active')}
                id="operation-theatre-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.cursor')}
                id="operation-theatre-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.lastupdated')}
                id="operation-theatre-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.microSec')}
                id="operation-theatre-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatre.timestampentry')}
                id="operation-theatre-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                id="operation-theatre-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.operationTheatre.hospital')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="operation-theatre-addedBy"
                name="addedBy"
                data-cy="addedBy"
                label={translate('tinyMedicRestApp.operationTheatre.addedBy')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalManagers
                  ? hospitalManagers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="operation-theatre-modifiedBy"
                name="modifiedBy"
                data-cy="modifiedBy"
                label={translate('tinyMedicRestApp.operationTheatre.modifiedBy')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalManagers
                  ? hospitalManagers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/operation-theatre" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default OperationTheatreUpdate;
